export const AVAILABLE_LANGUAGES_MAPPING = [
  { value: 'en', name: 'English' },
  { value: 'it', name: 'Italian' }
];
